import React from 'react';
import Link from 'gatsby-link';
import Img from 'gatsby-image';
import Script from 'react-load-script';
import graphql from 'graphql';

export default class PodcastsPage extends React.Component {
  handleScriptLoad() {
    if (typeof window !== `undefined` && window.netlifyIdentity) {
      window.netlifyIdentity.on('init', user => {
        if (!user) {
          window.netlifyIdentity.on('login', () => {
            document.location.href = '/admin/';
          });
        }
      });
    }
    window.netlifyIdentity.init();
  }

  render() {
    const { data } = this.props;
    const { edges: posts } = data.allMarkdownRemark;

    return (
      <section className="podcasts">
        <Script
          url="https://identity.netlify.com/v1/netlify-identity-widget.js"
          onLoad={() => this.handleScriptLoad()}
        />
        <div className="container">
          <div className="friends">
            {posts
              .filter(
                post => post.node.frontmatter.templateKey === 'podcasts-post'
              )
              .map(({ node: post }) => (
                <div className="friend" key={post.id}>
                  <a
                    className="post-link"
                    href={post.frontmatter.link}
                    target="_blank"
                  >
                    <Img
                      className="img-preview"
                      alt={post.frontmatter.title}
                      sizes={
                        post.frontmatter.featuredImage.childImageSharp.sizes
                      }
                    />
                  </a>
                </div>
              ))}
          </div>
        </div>
      </section>
    );
  }
}

export const pageQuery = graphql`
  query PodcastsQuery {
    allMarkdownRemark(sort: { order: DESC, fields: [frontmatter___date] }) {
      edges {
        node {
          excerpt(pruneLength: 400)
          id
          frontmatter {
            link
            templateKey
            featuredImage {
              childImageSharp {
                sizes(maxWidth: 600) {
                  ...GatsbyImageSharpSizes
                }
              }
            }
          }
        }
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/pages/podcasts/index.js